import type { Catalog } from "../../en";

export const agents: Catalog["build"]["agents"] = {
  title: "Mga agent",
  subtitle: "Bawat agent ay may sariling knowledge, audience at channels. Ang mga tao ay nakakakita lang ng mga agent na pinapayagan sa kanila.",
  search: "Maghanap ng agent…",
  searchLabel: "Maghanap ng agent",
  create: "Gumawa ng agent",
  notDeployed: "Hindi pa naka-deploy",
  plan: {
    used: "{{used}} sa {{limit}} agent ang nagamit sa {{plan}}",
    usedUnlimited: "{{used}} agent sa {{plan}}",
    remaining_one: "{{count}} natitira",
    remaining_other: "{{count}} natitira",
    full: "Naabot na ang limit",
    body: "Pinaghahatian ng mga agent ang buwanang message allowance ng workspace. Mas maraming agent at per-agent na limit sa mas mataas na plano.",
    compare: "Ikumpara ang mga plano",
    meterLabel: "Nagamit na agent",
  },
  card: {
    moreActions: "Iba pang aksyon para sa {{name}}",
    duplicate: "I-duplicate",
    pause: "I-pause",
    resume: "Ituloy",
    publish: "I-publish",
    settings: "Settings",
    delete: "Burahin",
    audienceOnly: "{{label}} lang",
    audiencePublic: "kahit sino, walang sign-in",
    convos: "Usapan · 7a",
    resolved: "Nalutas",
    sources: "Sources",
    model: "Model",
    modelDefault: "Default ng workspace",
    lastTrained: "Huling na-train",
    neverTrained: "Hindi pa na-train",
    processing_one: "{{count}} source ang pinoproseso pa",
    processing_other: "{{count}} source ang pinoproseso pa",
    open: "Buksan",
    playground: "Playground",
  },
  tile: {
    title: "Gumawa ng agent",
    body: "Magsimula sa industry template o sa blangkong agent.",
    slots_one: "{{count}} slot ang natitira sa {{plan}}",
    slots_other: "{{count}} slot ang natitira sa {{plan}}",
    full: "Mag-upgrade para magdagdag ng agent",
  },
  info: {
    title: "Paano nagtutulungan ang mga agent at access",
    link: "Audiences at Access",
    kbTitle: "Isang knowledge base, maraming agent.",
    kbBody: "Mag-upload ng dokumento nang isang beses at i-link sa kahit anong agent — walang dobleng file.",
    accessTitle: "Sinusuri ang access sa bawat paghahanap.",
    accessBody: "Hindi kailanman makukuha ng pampublikong bisita ang chunk na para sa naka-sign-in na audience, kahit hilingin pa nila.",
    channelsTitle: "Channels kada agent.",
    channelsBody: "Ilagay ang isang agent sa website at Messenger, at ang isa pa sa loob ng iyong portal.",
  },
  empty: {
    title: "Wala pang agent",
    body: "Gumawa ng unang agent mula sa template. Magsisimula ito bilang draft na masusubukan mo sa Playground.",
    noMatch: "Walang agent na tugma sa “{{query}}”",
    noMatchBody: "Subukan ang ibang pangalan o i-clear ang paghahanap.",
    clear: "I-clear ang paghahanap",
  },
  createDialog: {
    title: "Gumawa ng agent",
    subtitle: "Mababago mo ang lahat mamaya sa Agent Settings.",
    name: "Pangalan ng agent",
    namePlaceholder: "hal. Clinic Front Desk",
    nameRequired: "Maglagay ng pangalan para sa agent.",
    template: "Magsimula sa template",
    recommended: "Inirerekomenda",
    showAll: "Ipakita lahat ng template",
    showFewer: "Ipakita ang mas kaunti",
    templatesError: "Hindi ma-load ang mga template. Subukan muli.",
    audience: "Sino ang puwedeng gumamit",
    audienceHint: "Kinokontrol kung sino ang puwedeng mag-chat at aling sources ang puwede nitong hanapin.",
    audiencePublic: "{{label}} — kahit sino",
    audienceOnly: "{{label}} lang",
    copy: "Kopyahin ang knowledge mula sa",
    copyNone: "Huwag kopyahin — magsimula nang walang laman",
    copyOption: "{{name}} ({{count}} sources)",
    copyHint: "Nili-link ang kasalukuyang sources; walang muling ina-upload.",
    planNote: "Gagamitin nito ang {{next}} sa {{limit}} agent sa iyong {{plan}} plan. Nagsisimula bilang Draft ang bagong agent at hindi makikita hangga't hindi mo pa nai-publish.",
    planNoteUnlimited: "Nagsisimula bilang Draft ang bagong agent at hindi makikita hangga't hindi mo pa nai-publish.",
    submit: "Gumawa ng agent",
    created: "Nagawa ang agent — magdagdag ng knowledge para ma-train ito",
  },
  deleteDialog: {
    title: "Burahin ang {{name}}?",
    body: "Agad na titigil ang widget, Messenger page at chat link ng agent na ito. Itatago ang kasaysayan ng usapan ayon sa iyong retention policy, saka permanenteng buburahin.",
    confirmLabel: "I-type ang DELETE para kumpirmahin",
    confirmWord: "DELETE",
    submit: "Burahin ang agent",
    deleted: "Nabura ang agent. Naiwan ang mga knowledge source nito.",
  },
  toasts: {
    duplicated: "Na-duplicate bilang “{{name}}” — naiwan ang mga knowledge link",
    paused: "Naka-pause ang {{name}} — offline message na ang ipinapakita ng mga channel",
    resumed: "Live na ulit ang {{name}}",
    published: "Nai-publish ang {{name}}",
    failed: "Hindi gumana. Subukan muli.",
  },
};
